import * as http from '@/util/http'
import { z } from 'zod'

export const IndustrySchema = z.object({
  id: z.number(),
  name: z.string(),
})

export const CompanySchema = z.object({
  id: z.number(),
  name: z.string(),
  url: z.url().optional(),
  established_date: z.date().optional(),
  capital: z.number().int().optional(),
  employee_count: z.number().int().optional(),
  image_url: z.url().optional(),
  summary: z.array(z.string()).optional(),
  intro: z.any().optional(),
  industries: z.array(IndustrySchema).optional(),
  bookmarked: z.boolean(),
})

export type Company = z.input<typeof CompanySchema>

export async function fetchBookmarkedCompanies(): Promise<Company[]> {
  const { data } = await http.get<Company[]>('/api/v1/company', {
    queryParams: { bookmarked: true },
  })
  return data
}

export type BookmarkAction = 'ADD' | 'REMOVE'

export type SetBookmarkPayload = {
  id: number
  action: BookmarkAction
}

export async function setBookmark({ id, action }: SetBookmarkPayload) {
  if (id) return http.put(`/api/v1/company/${id}/bookmark`, { payload: { action } })
}
